import { render, staticRenderFns } from "./SampleQuestionnaire.vue?vue&type=template&id=feac5a22"
import script from "./SampleQuestionnaire.vue?vue&type=script&lang=ts"
export * from "./SampleQuestionnaire.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports